export const SAVE_ADJUSTMENT = 'SAVE_ADJUSTMENT';
export const SAVE_ADJUSTMENT_SUCCESS = 'SAVE_ADJUSTMENT_SUCCESS';
export const SAVE_ADJUSTMENT_FAILURE = 'SAVE_ADJUSTMENT_FAILURE';

export const REMOVE_ADJUSTMENT = 'REMOVE_ADJUSTMENT';
export const REMOVE_ADJUSTMENT_SUCCESS = 'REMOVE_ADJUSTMENT_SUCCESS';
export const REMOVE_ADJUSTMENT_FAILURE = 'REMOVE_ADJUSTMENT_FAILURE';

export const FETCH_ADJUSTMENT_ATTACHMENTS = 'FETCH_ADJUSTMENT_ATTACHMENTS';
export const FETCH_ADJUSTMENT_ATTACHMENTS_SUCCESS = 'FETCH_ADJUSTMENT_ATTACHMENTS_SUCCESS';
export const FETCH_ADJUSTMENT_ATTACHMENTS_FAILURE = 'FETCH_ADJUSTMENT_ATTACHMENTS_FAILURE';

export const FETCH_INITIAL_DATA_FOR_ADJUSTMENT_MODAL = 'FETCH_INITIAL_DATA_FOR_ADJUSTMENT_MODAL';
export const FETCH_INITIAL_DATA_FOR_ADJUSTMENT_MODAL_SUCCESS = 'FETCH_INITIAL_DATA_FOR_ADJUSTMENT_MODAL_SUCCESS';
export const FETCH_INITIAL_DATA_FOR_ADJUSTMENT_MODAL_FAILURE = 'FETCH_INITIAL_DATA_FOR_ADJUSTMENT_MODAL_FAILURE';
